import { InputState, input } from '../input';
import { StoreNode } from '../../store';
import { action, makeObservable, observable } from 'mobx';
import { Store } from '../../store/store';

type Props = {
  initialValue?: string,
}

export class AdsItemState
  extends StoreNode {

  isSyncing = false;
  isSynced = false;
  isLocked = false;

  error: string | null = null;

  constructor(store: Store, props?: Props) {
    super(store, props);
    makeObservable(this, {
      isSyncing: observable,
      isSynced: observable,
      isLocked: observable,
      error: observable,
      setSyncing: action,
      setSynced: action,
      setError: action,
      lock: action,
      unlock: action,
    });

    this.urlInput = input(this, {
      name: 'vastUrl',
      isRequired: false,
      placeholder: "VAST URL",
      disabled: (_input: InputState) => {
        return this.isLocked
      },
      error: input => {
        if (this.isSynced)
          return null;

        // const error = this.props?.checkLinkValidity(input.value);

        if (input.isRequired && input.isEmpty)
          return 'Required field';

        // if (!input.isEmpty && error)
        //   return error;

        return null;
      }
    });

    this.urlInput.loadValue(this.props?.initialValue);
  }

  readonly urlInput: InputState;

  setSyncing(value: boolean) {
    this.isSyncing = value;
  }

  setSynced(value: boolean) {
    this.isSynced = value;
  }

  setError(value: string | null) {
    this.error = value;
  }

  lock() {
    this.isLocked = true;
  }

  unlock() {
    this.isLocked = false;
  }
}